import { Certification } from './certification';

export interface Certifications {
  totalCertifiedDevelopers: number;
  certifications: Certification[];
  yearToDateSpend: {
    value: number;
    currencyCode: string;
  };
}
